<template>
  <div>
    <!-- <div class="w-100 d-flex justify-content-end mb-2">
      <b-button
        variant="primary"
        @click="handleAddItem"
      >
        {{$t('modal.nameModalPost')}}
      </b-button>
    </div> -->

    <b-card>
      <div class="_table">
        <b-table
          :fields="fields"
          :items="items"
          responsive
        >
          <template #cell(id)="data">
            <span>
              {{data.index + 1}}
            </span>
          </template>
        </b-table>
      </div>
    </b-card>

  </div>
</template>

<script>
  import { getRegions } from '../../../api/endpoints/regions'

  export default {
    name: 'Regions',
    data() {
      return {
        items: [],
        fields: [
          {key: 'id', label: "№"},
          {key: 'name', label: this.$t('table.name.label')},
        ]
      }
    },
    created() {
      getRegions().then( response => {
        this.items = response.data.data
      })
    },
    methods: {
      handleAddItem() {

      }
    }
  }
</script>